import React from "react";
import PropTypes from "prop-types";
import { Accordion, Card, Button, ListGroup } from "react-bootstrap";
import NavbarLink from "../NavbarLink";
const ContactTypes = ({ contact_types_add }) => {
    return (
        <Card id="contact-types-toggle-list">
            <Card.Header>
                <Accordion.Toggle
                    as={Button}
                    variant="light"
                    eventKey="contact-types-toggle-list"
                >
                    <span className="text-dark">
                        <i className="fa fa-users" /> Contact Types
                    </span>
                </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey="contact-types-toggle-list">
                <Card.Body className="p-0">
                    <ListGroup>
                        <ListGroup.Item>
                            <NavbarLink
                                to="/contacts/types"
                                className="dropdown-item"
                                label={`View Contact Types`}
                            />
                        </ListGroup.Item>

                        {contact_types_add && (
                            <ListGroup.Item>
                                <a
                                    href="/contacts/types/create"
                                    className="dropdown-item"
                                >
                                    Add Contact Type
                                </a>
                            </ListGroup.Item>
                        )}
                    </ListGroup>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    );
};

ContactTypes.propTypes = { contact_types_add: PropTypes.bool };

export default ContactTypes;
